import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../components/ui/dialog";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

export default function WeekDialog({ open, onOpenChange, onCreate, duplicateFrom }) {
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (!start || !end) return toast.error("Selecciona fecha de inicio y fin");
    if (end < start) return toast.error("La fecha final no puede ser anterior al inicio");
    setLoading(true);
    try {
      await onCreate(start, end, duplicateFrom || null);
      onOpenChange(false);
      setStart(""); setEnd("");
    } finally { setLoading(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md rounded-sm">
        <DialogHeader>
          <DialogTitle className="font-heading tracking-tight">
            {duplicateFrom ? "Duplicar semana anterior" : "Crear nueva semana"}
          </DialogTitle>
          <DialogDescription>Selecciona el rango de fechas de la semana de nómina.</DialogDescription>
        </DialogHeader>
        <p className="text-sm text-slate-500 -mt-2">
          {duplicateFrom
            ? "Se copiarán los trabajadores, asistencias y préstamos de la semana seleccionada al nuevo periodo."
            : "Se agregarán todos los trabajadores actuales con asistencia y préstamos en blanco."}
        </p>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <Label className="text-xs">Fecha de inicio (Lunes)</Label>
            <Input type="date" value={start} onChange={(e) => setStart(e.target.value)} data-testid="week-start" className="h-9 font-mono-data" />
          </div>
          <div>
            <Label className="text-xs">Fecha final (Sábado)</Label>
            <Input type="date" value={end} onChange={(e) => setEnd(e.target.value)} data-testid="week-end" className="h-9 font-mono-data" />
          </div>
        </div>
        <div className="flex justify-end gap-2">
          <Button variant="ghost" onClick={() => onOpenChange(false)}>Cancelar</Button>
          <Button onClick={submit} disabled={loading} data-testid="week-create-confirm" className="bg-blue-600 hover:bg-blue-700">
            {loading ? "Creando..." : "Crear semana"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
